import { Component, OnInit } from '@angular/core';
import {ApiAccess, Profile} from '../models/profile.model';
import {NotificationBuilder} from '../shared/notificationBuilder';
import {ProfileService} from '../profile/profile.service';
import {AuthenticationService} from '../authentication/authentication.service';
import {HelperService} from '../services/helper.service';

declare var swal: any;

@Component({
  selector: 'app-setup',
  templateUrl: './setup.component.html',
  styleUrls: ['./setup.component.css']
})
export class SetupComponent implements OnInit {
  profile: Profile;
  script: string = "";
  apiAccess: ApiAccess;
  loading = false;
  companyId: string;
  public isAdmin: boolean;
  loadingMessage: string = "Conectando com a API. Isso pode demorar um pouco!";
  accountApiToken: string;
  isGeneric: boolean;

  constructor(
    private profileService: ProfileService,
    private notificationBuilder: NotificationBuilder,
    private authenticationService: AuthenticationService,
    private helperService: HelperService
  ) { }

  ngOnInit(): void {
    debugger
    this.isAdmin = localStorage.getItem("admin-token") != null;
    this.profileService.getCurrentUserInfo().subscribe((data) => {
      debugger;
      this.profile = data;
      this.isGeneric = this.profile.platformInfo.seoName != 'cartx' &&  this.profile.platformInfo.seoName != 'woocommerce-flower' && this.profile.platformInfo.seoName != 'irroba' && this.profile.platformInfo.seoName != 'xtech-flower' && this.profile.platformInfo.seoName != 'loja-integrada-flower' && this.profile.platformInfo.seoName != 'vtex-flower' && this.profile.platformInfo.seoName != 'traycorp' && this.profile.platformInfo.seoName != 'tray-pollinator' && this.profile.platformInfo.seoName != 'nuvemshop-flower' && this.profile.platformInfo.seoName != 'vnda';

      this.companyId = this.authenticationService.getCompanySelected()
      this.accountApiToken = this.authenticationService.getAccountApiToken();
      this.profileService.getApiAccess().subscribe((model) => {
        if (model.success) {
          this.apiAccess = model.data;
        }
      });
      this.script = this.helperService.getScript(this.profile);
    });
  }

  copyToClipboard() {
    let script = document.getElementById("scriptHelper") as HTMLInputElement;
    script.value = "";
    script.value = this.script;
    script.select();

    document.execCommand("Copy");
    this.notificationBuilder.showNotification(
      "success",
      1000,
      "O script foi copiado no seu clipboard"
    );
  }

  saveApiAccess() {
    debugger
    this.loading = true
    this.profileService.updateApiAccess(this.apiAccess).subscribe(data => {
      this.loading = false
      if (data != null) {
        this.notificationBuilder.showNotification('success', 7000, 'Chave de API salva... vamos verificar a validade em breve.')
      } else {
        this.notificationBuilder.showNotification('danger', 2000, data.error)
      }
    })
  }

  saveConfig() {
    if (!this.profile.integrationActive) {
      swal({
        title: 'Ativar/Desativar Polen',
        text: "Ao clicar 'confirmar' a caixinha de doação não vai mais aparecer na sua loja. A sua assinatura no Polen permanece ativa, para mais informações, fale com  a gente!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Voltar',
        reverseButtons: true
      }).then((result) => {

      }, function (dismiss) {

      })
    }
    else {
      this.profileService.updateProfile(this.profile).subscribe(data => {
        this.loading = false
        if (data) {
          this.profileService.clearStoreCache(this.profile.storeSeoName).subscribe()
          this.notificationBuilder.showNotification('success', 1000, 'Seus dados foram alterados com sucesso')
          window.location.reload()
        } else {
          this.notificationBuilder.showNotification('danger', 1000, 'ocorreu algum erro durante a alteração dos seus dados')
        }
      })
    }
  }

  lookforScript() {
    this.notificationBuilder.showNotification('success', 1000, 'Procurando pelo Script Polen no domínio: ' + this.profile.domain)
    this.profileService.lookforScript(this.profile.storeSeoName).subscribe(data => {
      this.loading = false
      if (data.success) {
        this.profileService.clearStoreCache(this.profile.storeSeoName).subscribe()
        if (data.hasScript) {
          this.notificationBuilder.showNotification('success', 1000, 'Script encontrado na sua loja!')
        }
        else {
          this.notificationBuilder.showNotification('danger', 1000, 'O script não foi encontrado. Caso já tenha inserido, por favor, fale com nosso suporte para ativarmos manualmente.')
        }

      } else {
        this.notificationBuilder.showNotification('danger', 1000, data.error)
      }
    })
  }

  updateApiStatus() {
    debugger
    this.loading = true
    this.profileService.updateApiStatus().subscribe(data => {
      debugger
      this.loading = false
      if (data.success) {
        if (data.valid) {
          this.notificationBuilder.showNotification('success', 7000, 'API está conectada com o Polen.')
        } else {
          this.notificationBuilder.showNotification('danger', 2000, data.error)
        }
      } else {
        this.notificationBuilder.showNotification('danger', 2000, data.error)
      }
    })
  }

  sendToDeveloper() {

    swal({
      title: 'Enviar por E-mail',
      text: 'Envie aqui para quem vai adicionar o script. Leva em média 5 minutos!',
      html:
        '<input id="name-dev" class="swal2-input" placeholder="Nome">' +
        '<input id="email-dev" type="email" placeholder="E-mail" class="swal2-input">',
      focusConfirm: false
    })
      .then((ok) => {
        if (ok) {
          let name = $("#name-dev").val()
          let email = $("#email-dev").val()
          this.helperService.sendEmailScriptToDeveloper(email, name, this.profile.storeSeoName)
          swal({
            type: 'success',
            title: 'Script Enviado =)',
            text: 'Enviamos o script por e-mail para ' + name + '. De qualquer maneira, avisa ele(a) também. Leva menos de 5 para add o Polen ;)',
          })
        }
      })

  }

}
